import { render, staticRenderFns } from "./DashboardData.vue?vue&type=template&id=5003e262&scoped=true&"
import script from "./DashboardData.vue?vue&type=script&lang=js&"
export * from "./DashboardData.vue?vue&type=script&lang=js&"
import style0 from "./DashboardData.vue?vue&type=style&index=0&id=5003e262&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5003e262",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/buddy/kontalk/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {VAvatar,VBtn,VFlex,VIcon,VLayout,VTooltip})
